import { api } from '@/services/api/AxiosBaseService'
import { createCrudService } from '@/services/api/createCrudService'

export interface UserAddressData {
  postalCode: string | null
  address: string | null
  number: string | null
  complement: string | null
  district: string | null
  cityId: string | null
  stateId: string | null
}
export interface UserBankData {
  bankId: string | null
  beneficiary: string | null
  document: string | null
  agency: string | null
  account: string | null
  pixKey: string | null
  transaction: string | null
  type: string | null
  accountType: string | null
}

export interface UserItem {
  id: string
  name: string
  username: string
  email: string | null
  whatsapp: string | null
  type: string
  status: 'ATIVO' | 'INATIVO'
  slug: string | null
  admissionDate?: string | null
  managerId?: string | null
  commissionId?: string | null
  networkCommissionPercentage: number | null
  credentialingCommissionId?: string | null
  administrativeManagerName?: string | null
  administrativeManagerEmail?: string | null
  billingManagerName?: string | null
  billingManagerEmail?: string | null
  hierarchy?: { id: string; name: string } | null
  manager?: { id: string; name: string } | null
  company?: { id: string; name: string } | null
  address?: UserAddressData | null
  bankDetails?: UserBankData | null
  formatted?: { createdAt?: string; networkCommissionPercentage?: string }
}

export interface UserSimpleOption { id: string; name: string; type: string; slug: string | null; managerId: string | null }

/** Usuário serializado (shape do sign-in) + token — resposta do impersonate. */
export interface UserImpersonation {
  accessToken: string
  id: string
  name: string
  type: string
  [k: string]: unknown
}

const base = createCrudService<UserItem>('/administractive/users', { searchField: 'name' })

export const UsersService = {
  ...base,
  /**
   * Gera acesso como o usuário (impersonação) — disponível para parceiros
   * (diretor/supervisor/afiliado/vendedor). O backend valida o escopo: admin
   * visualiza qualquer um; diretor/supervisor/afiliado só os da sua rede.
   */
  async impersonate(id: string): Promise<UserImpersonation> {
    const r = await api.get<{ data: UserImpersonation }>(`/administractive/users/${id}/impersonate`)
    return r.data.data
  },
  /** Usuários ativos de determinados tipos — usado para selects de "Gestor". */
  async byType(types: string[]): Promise<UserSimpleOption[]> {
    const r = await api.get<{ data: UserSimpleOption[] }>('/administractive/users/by-type', { params: { types } })
    return r.data.data
  },
  /** Verifica se um slug já existe (afiliados). */
  async slugExists(slug: string): Promise<boolean> {
    const r = await api.get<{ data: { exists: boolean } }>('/administractive/users/verify-slug-exists', { params: { slug } })
    return r.data.data.exists
  },
}
